import { createSelector } from 'reselect';

const selectSimCardsState = (state) => state.get('simCards');

export const selectOrderSubscriptionsFinished = createSelector(
  selectSimCardsState,
  (simCards) => simCards.get('orderSubscriptionsFinished')
)

